import { Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses,
   TableContainer, TableHead, TablePagination, TableRow, Typography,ToggleButton } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import AcountsServices from "../../../Services/MasterBilling/AcountsServices";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.white,
      textAlign: "center",
      padding: theme.spacing(0.5),
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function Payment() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    fontFamily: 'Times New Roman',
    color: "red",
  };
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [BillPaymentType, setBillPaymentType] = useState([]);
  const [Filtereddetails, setFiltereddetails] = useState([]);
  const [payment, setpayment] = useState({
    paytype: '', oldPaymentType: ''
  });
  const [error, setError] = useState(false);
  const [AcSaveDsa, setAcSaveDsa] = useState(false);
  const [AcUpdateDsa, setAcUpdateDsa] = useState(true);
  const [AcDeleteDsa, setAcDeleteDsa] = useState(true);

  const [AcSave, setAcSave] = useState(false);
  const [AcUpdate, setAcUpdate] = useState(false);
  const [AcDelete, setAcDelete] = useState(false);

  const pay_typehandlechange = (e) => {
    setpayment({ ...payment, paytype: e.target.value });
  };
  //icon
  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{ color: 'red' }} />
  }
  //getData
  const getData = async () => {
    AcountsServices.getBillPaymentType().then((res) => {
      setBillPaymentType(res.data);
      setFiltereddetails(res.data);
    })
  }

  useEffect(() => {
    const getData = async () => {
      AcountsServices.getBillPaymentType().then((res) => {
        setBillPaymentType(res.data);
        setFiltereddetails(res.data)
      })
    }
    getData();
  }, []);

  //tableClick
  const EditPaymentDetails = (item) => {
    setError(false);
    setAcSaveDsa(true); setAcUpdateDsa(false); setAcDeleteDsa(false);
    setAcSave(false); setAcUpdate(false); setAcDelete(false);
    setpayment({ ...payment, paytype: item.paymentType, oldPaymentType: item.paymentType });
  }

  //ClickEvent
  const validate = () => {
    if (payment.paytype !== '') {
      return true;
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Please Enter A PaymentTypeName..!');
      setError(true);
      document.getElementById('PaymentTypeName').focus();
    }
    return false;
  }

  const insertPaymentType = () => {
    if (validate() === true) {
      setAcSaveDsa(true); setAcSave(true);
      let details = { paymentType: payment.paytype }
      AcountsServices.insertPaymentType(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh(); getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
      });
    }
  }
  const updatePaymentType = () => {
    if (validate() === true) {
      if (payment.oldPaymentType !== '') {
        setAcUpdateDsa(true); setAcUpdate(true);
        let details = { paymentType: payment.paytype, oldPaymentType: payment.oldPaymentType }
        AcountsServices.updatePaymentType(details).then((res) => {
          const message = res.data.message;
          if (message.toString() === 'SUCCESS') {
            setOpen(true); setSeverity('success'); setMessage(message);
          } else {
            setOpen(true); setSeverity('error'); setMessage('Updation Failed');
          } refresh(); getData();
        }).catch(error => {
          setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
        });
      } else {
        setOpen(true); setSeverity('warning'); setMessage('Please Select A PaymentTypeDetails Table..!');
      }
    }
  }
  const deletePaymentType = () => {
    if (payment.oldPaymentType !== '') {
      setAcDeleteDsa(true); setAcDelete(true);
      setalertopen(true)
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Please Select A PaymentTypeDetails Table..!');
    }
  }
  const refresh = () => {
    setPage(0)
    setError(false); setAcSaveDsa(false); setAcUpdateDsa(true); setAcDeleteDsa(true);
    setAcSave(false); setAcUpdate(false); setAcDelete(false);
    setpayment({ ...payment, paytype: '', oldPaymentType: '' });
    document.getElementById('PaymentTypeName').focus();
  }


  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }

  //table search
  const PaymentTypeSrch = () => {
    return <input className="searchBoxes" onChange={(e) => { PaymentTypeOnchange(e.target.value) }} placeholder="Search" />
  }
  const PaymentTypeOnchange = (searchedVal) => {
    const FilterValues = BillPaymentType.filter((trns) => {
      return trns.paymentType.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails(BillPaymentType)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //alertbox
  const [alertopen, setalertopen] = useState(false);

  const alertonClickOpen = (item) => {
    setpayment({ ...payment, oldPaymentType: item.paymentType })
    setalertopen(true)
  }

  const alertNoOnClick = () => {
    refresh();
    setalertopen(false)
  }

  const alertYesOnClick = () => {
    AcountsServices.deletePaymentType(payment.oldPaymentType).then((res) => {
      const message = res.data.message;
      if (message.toString() === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
      } refresh(); getData();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
    });
    setalertopen(false)
  }

  const navigate = useNavigate();
  const BackBotton =()=>{
    navigate('/Billpaidby');
  }
  const ForwordBotton =()=>{
    navigate('/Printedtype');
  }
  return (
    <div>
      <Dialog open={alertopen}>
        <DialogTitle>
          <center style={{ fontFamily: 'Times New Roman'}}><h6>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman'}}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
            <Row>
                <Col xs={1}>
          {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }} /> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                Payment Details Entry
              </Typography><hr></hr>
              </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={5}>
                  <label style={mystyle1}>PaymentTypeName*</label>
                </Col>
                <Col xs={7}>
                  <Form.Control size="sm" type="text" style={mystyle} value={payment.paytype}
                    isInvalid={error} onChange={pay_typehandlechange} id='PaymentTypeName' />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" disabled={AcSaveDsa} onClick={insertPaymentType}>
                    {AcSave ? 'Processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" disabled={AcUpdateDsa} onClick={updatePaymentType}>
                    {AcUpdate ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="danger" size="sm" disabled={AcDeleteDsa} onClick={deletePaymentType}>
                    {AcDelete ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="secondary" size="sm" onClick={refresh}>
                    refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1%" }}>
              <ItemPap1>
              <Row>
                  <Col xs={11}>
                <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                  Existing  Payment Type
                </Typography>
                </Col>
                <Col xs={1}>
                 {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /></ToggleButton>  */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360 }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell style={{ width: "1rem" }}>SlNo</StyledTableCell>
                        <StyledTableCell>Payment Type {PaymentTypeSrch()}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Filtereddetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => (
                          <StyledTableRow hover key={item.paymentType} onClick={() => EditPaymentDetails(item)}>
                            <StyledTableCell style={{ width: "1rem",textAlign: 'center'}}>{item.serialNumber}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.paymentType}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}><lu onClick={() => alertonClickOpen(item)}>{deleteicon()}</lu></StyledTableCell>
                          </StyledTableRow>))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={Filtereddetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Payment;
